import { render, staticRenderFns } from "./StudiosMapView.vue?vue&type=template&id=c38602ac&scoped=true"
import script from "./StudiosMapView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudiosMapView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudiosMapView.vue?vue&type=style&index=0&id=c38602ac&prod&lang=scss&scoped=true"
import style1 from "./StudiosMapView.vue?vue&type=style&index=1&id=c38602ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38602ac",
  null
  
)

export default component.exports